<template>
    <div>
        <b-row class="font-weight-bold h6 border-bottom pb-1 mb-1">
            <b-col class=" mb-0">ID</b-col>
            <b-col class=" mb-0" cols="4">Type</b-col>
            <b-col class=" mb-0">Metal</b-col>
            <b-col class="mb-0 text-right mr-3">Weight</b-col>
        </b-row>
        <div class="batch-scroll pr-3" style="min-height:25px">
            <draggable v-model="dataFlattened" group="orders" :move="chechMove">
                <b-row :id="`click-control-${item.id}`" v-for="(item, index) in dataFlattened"
                        :class="[ `depth-${item.depth}`, item.indexedType !== 'bag' ? 'pointer' : '' ]">
                    <b-col  @contextmenu.prevent="rightClickHandler($event, item)">
                        <a :href="`kit/view/${item.order_id}`"
                           :class="item.indexedType !== 'bag' ? 'text-dark' : '' ">
                            {{ item.id }}</a>
                    </b-col>

                    <b-col cols="4" @contextmenu.prevent="rightClickHandler($event, item)">{{ item.type }}</b-col>

                    <b-col @contextmenu.prevent="rightClickHandler($event, item)">{{ item.metal | titleCase }}</b-col>

                    <b-col class="text-right" @contextmenu.prevent="rightClickHandler($event, item)">{{ item.weight }}</b-col>
                   <!-- </b-row> -->

                    <b-popover ref="popover" :id="`click-control-${item.id}`" :target="`click-control-${item.id}`">
                        <div class="">
                            <b-list-group>
                                <b-list-group-item href="#" @click="moveItem('binned', item)">
                                    <i class="mr-1 fa-fw fa-solid fa-inbox fa-xs--"></i>
                                    <span class="font-weight-bold">Move to Binned</span> (melt)</b-list-group-item>

                                <b-list-group-item href="#" @click="moveItem('pulled', item)">
                                    <i class="mr-1 fa-fw fa-solid fa-tags text-success fa-xs--"></i>
                                    <span class="font-weight-bold">Move to Held</span></b-list-group-item>

                                <b-list-group-item href="#" @click="moveItem('zerovalue', item)">
                                    <i class="mr-1 fa-fw fa-solid fa-magnet fa-xs--" style="color: #c40285;"></i>
                                    <span class="font-weight-bold">Move to Zero-Value</span></b-list-group-item>

                                <b-list-group-item href="#" @click="moveItem('exception', item)">
                                    <i class="mr-1 fa-fw fa-solid fa-question-circle text-danger fa-xs--"></i>
                                    <span class="font-weight-bold">Move to Exception</span></b-list-group-item>
                            </b-list-group>
                        </div>
                    </b-popover>
                </b-row>
            </draggable>
        </div>

    </div>
</template>



<script>
    import draggable from 'vuedraggable';
    import _ from 'lodash';
    export default {
        name: 'batch-order-table',
        components: {
            draggable,
        },
        props: ['bags', 'items', 'path', 'orderItem', 'statuses', 'orderStatues'],
        data() {
            return {
                bagsWithItems: null,
                localStatuses: null,
                localOrderStatues: null,
            };
        },
        created() {
            this.createBagsWithChildren();
            this.createLocalCopies();
            window.addEventListener("click", (event) => {
                this.$root.$emit('bv::hide::popover');
            });
        },
        methods: {
            createLocalCopies() {
                //this.localStatuses = JSON.parse(JSON.stringify(this.statuses));
                //this.localOrderStatues = JSON.parse(JSON.stringify(this.orderStatues.statuses));
            },
            chechMove(e) {
                //do not allow repositioning
                return false;
            },

            // signals parent to move bags from one section to another
            moveItem(section, item) {
                this.statuses[section].items.push(item);
                this.$root.$emit('bv::hide::popover');
            },





            rightClickHandler(e, row) {
                this.$root.$emit('bv::hide::popover');
                let popover = 'click-control-' + row.id;
                this.$root.$emit('bv::show::popover', popover)
            },


            // creates an array of bags
            // each 'bag is an array of items included in each bag, including the bag itself as index 0.
            createBagsWithChildren() {

            }
        },
        computed: {
            dataFlattened() {
                let flatArray = [];
                let masterIndex = 0;
                _.forEach(this.bags,(bag) => {
                    let bagIndex = masterIndex;
                    flatArray[bagIndex] = bag;
                    flatArray[bagIndex].component_id = "Bag " + bag.id;
                    flatArray[bagIndex].indexedType = "bag";
                    masterIndex++;

                    flatArray[bagIndex].depth = 0;
                    let bagWeight = 0;
                    flatArray[bagIndex].type = bag.bagType.bag_dwt + ' ' + bag.bagType.name;

                    //********* START OF BAG CHILDREN ******
                    _.forEach(bag.inventory, (inventory) => {
                        let itemIndex = masterIndex;
                        flatArray[itemIndex] = inventory;
                        flatArray[itemIndex].component_id =  "Item " + inventory.id;
                        flatArray[itemIndex].indexedType = "inventory";
                        masterIndex++;

                        let itemWeight = 0;
                        flatArray[itemIndex].depth = 1;
                        flatArray[itemIndex].metal = inventory.class_name;
                        flatArray[itemIndex].type = inventory.type_name;

                        //************ START OF ITEM CHILDREN *****************
                       _.forEach(inventory.children, (component)=> {
                           let componentIndex = masterIndex;
                           flatArray[componentIndex] = component;
                           flatArray[componentIndex].id = component.component_id;
                           flatArray[itemIndex].component_id =  "Comp " + component.component_id;
                           flatArray[itemIndex].indexedType = "component";
                           masterIndex++;

                           flatArray[componentIndex].depth = 2;
                           flatArray[componentIndex].type = component.type_name;
                           flatArray[componentIndex].weight = component.tare_weight + ' ' + component.weight_type;
                           flatArray[componentIndex].metal = component.class_name + " " + component.purity + " " + component.purity_type;
                           //set metal of invnetory to child 0
                           if(componentIndex - 1 == itemIndex) {
                               flatArray[itemIndex].metal = component.class_name + " " + component.purity + " " + component.purity_type;
                           }
                           itemWeight += parseFloat(component.aggregate_dwt);
                       });
                        //************ END OF ITEM CHILDREN *****************
                        flatArray[itemIndex].weight = itemWeight + ' dwt';
                        //set bag index to item metal
                        if(itemIndex-1 == bagIndex) {
                            flatArray[bagIndex].metal = flatArray[itemIndex].metal;
                        }
                        bagWeight += itemWeight;
                    });
                    //********* END OF BAG CHILDREN ******
                    flatArray[bagIndex].weight = (bagWeight+parseFloat(bag.bagType.bag_dwt)) + ' dwt';
                });
                return flatArray;
            }
        },
        watch: {
            items() {
            }
        }
    };
</script>

<style scoped>


    .batch-scroll {
        max-height: 400px;
        overflow: scroll;
        overflow-x: hidden;
    }

    .depth-0 {
        color: #000;
    }
    .depth-1 {
        padding-left: 15px;
        color: #13b0df;
    }
    .depth-2 {
        padding-left: 25px;
        color: #7ac1d9;
    }

</style>
